import { yupResolver } from '@hookform/resolvers/yup';
import { useTheme } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

import { useSnackbar } from 'src/components/snackbar';
import { useAxiosClientContext } from 'src/http/context/axios-client-context';
import { BenefitsConfigRepository } from 'src/repositories/benefits-config/benefits-config.repository';

export const useCategoryCollapse = (row: any, getData: () => void) => {
  const theme = useTheme();
  const [success, setSuccess] = useState(false);
  const enqueueSnackbar = useSnackbar();
  const api = useAxiosClientContext();
  const repository = new BenefitsConfigRepository(api);

  function delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const defaultValues = useMemo(
    () => ({
      name: row?.name || '',
      types: (row?.types?.length ? row.types : [row?.type].filter(Boolean)) as string[],
    }),
    [row]
  );

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        name: Yup.string().required('Campo obrigatório'),
        types: Yup.array()
          .of(Yup.string().oneOf(['events', 'restaurant', 'stores', 'service'] as string[]).required())
          .min(1, 'Selecione pelo menos um tipo')
          .required(),
      })
    ),
    defaultValues,
  });

  const {
    handleSubmit,
    setValue,
    watch,
    formState: { isSubmitting },
  } = methods;
  const values = watch();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = event.target;
    setValue('types', checked ? [...values.types, value] : values.types.filter((type) => type !== value), {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const onSubmit = handleSubmit(async (data) => {
    const object = {
      name: data.name,
      type: data.types[0],
      types: data.types,
      status: 'active',
    };
    try {
      if (row.name === '') {
        const response = await repository.create(object);
        if (response.isLeft()) {
          throw new Error(response.value.message);
        }
        setSuccess(true);
        await delay(1500);
        getData();
      } else {
        const response = await repository.update(row.id, object);
        if (response.isLeft()) {
          throw new Error(response.value.message);
        }
        setSuccess(true);
        await delay(1500);
        getData();
      }
    } catch (error) {
      enqueueSnackbar.toastWarning(error);
    }
  });

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [success]);

  return {
    theme,
    isSubmitting,
    success,
    values,
    handleChange,
    onSubmit,
    methods,
  };
};
